import { render, staticRenderFns } from "./ReplacementOrderAutomation.vue?vue&type=template&id=a056ec90&scoped=true"
import script from "./ReplacementOrderAutomation.vue?vue&type=script&lang=js"
export * from "./ReplacementOrderAutomation.vue?vue&type=script&lang=js"
import style0 from "./ReplacementOrderAutomation.vue?vue&type=style&index=0&id=a056ec90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a056ec90",
  null
  
)

export default component.exports